import { gql } from "@apollo/client";

export const CREATE_TEMPLATE = gql`
  mutation createTemplate(
    $input: CreateInvoiceInterpretationTemplateInput!
    $clientIdentifier: String
  ) {
    invoiceInterpretation {
      createTemplate(input: $input, clientIdentifier: $clientIdentifier) {
        id
        success
      }
    }
  }
`;
